/**
 * admin-views domain (doc 01 A2.5 / A3.1). Read-only query surface. Types mirror
 * the API's `admin-views/schemas.ts` interfaces verbatim (mark for consolidation).
 */
import { download, get } from './transport.js';
/** `GET /api/admin-views/workforce` */
export function workforce(options) {
    return get('/api/admin-views/workforce', options);
}
/** `GET /api/admin-views/sessions/:id` */
export function session(id, options) {
    return get(`/api/admin-views/sessions/${id}`, options);
}
/** `GET /api/admin-views/verification` */
export function verification(filter = {}, options) {
    return get('/api/admin-views/verification', {
        ...options,
        query: { ...filter },
    });
}
/** `GET /api/admin-views/exceptions` */
export function exceptions(filter = {}, options) {
    return get('/api/admin-views/exceptions', {
        ...options,
        query: { ...filter },
    });
}
function toCsvExport(result) {
    return { text: result.text, filename: result.filename, truncated: result.truncated };
}
/** `GET /api/admin-views/export/workforce` — workforce board as CSV (reporting:export). */
export function exportWorkforceCsv(options) {
    return download('/api/admin-views/export/workforce', options).then(toCsvExport);
}
/** `GET /api/admin-views/export/verification` — verification summary as CSV (reporting:export). */
export function exportVerificationCsv(filter = {}, options) {
    return download('/api/admin-views/export/verification', {
        ...options,
        query: { ...filter },
    }).then(toCsvExport);
}
/** `GET /api/admin-views/export/exceptions` — exception panel as CSV (reporting:export). */
export function exportExceptionsCsv(filter = {}, options) {
    return download('/api/admin-views/export/exceptions', {
        ...options,
        query: { ...filter },
    }).then(toCsvExport);
}
/**
 * `GET /api/admin-views/export/payroll` — approved hours per worker per pay
 * period as CSV (reporting:export). Sourced from the immutable
 * approved-timesheet snapshot only. HOURS ONLY: no rate, no pay is computed.
 *
 * ORGANIZATION-WIDE OR NOT AT ALL. Unlike every other export here, this one is
 * not narrowed to the caller's caseload — it answers 403 to a reader without
 * `timekeeping:read_all`. A payroll file is handed to a payroll processor as the
 * answer to "who worked how many hours"; a caseload-shaped one is
 * indistinguishable from a complete one, and the failure mode is people not
 * being paid rather than a misread number. Render the refusal as a boundary, not
 * as a load error.
 */
export function exportPayrollCsv(filter = {}, options) {
    return download('/api/admin-views/export/payroll', {
        ...options,
        query: { ...filter },
    }).then(toCsvExport);
}
//# sourceMappingURL=adminViews.js.map